import React from 'react';
import { Dropdown } from 'react-bootstrap';
import Button from '../UI/button';
import cn from 'classnames';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ProfileAvatar } from '../../shared/components/ProfileAvatar/ProfileAvatar';
type Props = {
  children: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

const ProfileBtn = React.forwardRef<HTMLButtonElement, Props>(
  ({ children, onClick }, ref) => {
    return (
      <Button
        className='rounded-circle profile-btn'
        variant='light'
        height={50}
        width={50}
        ref={ref}
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        {children}
      </Button>
    );
  }
);

type ProfileBodyProps = {
  children: React.ReactNode;
  style: React.CSSProperties;
  className: string;
  ['aria-labelledby']: string;
};

const ProfileBody = React.forwardRef<HTMLDivElement, ProfileBodyProps>(
  ({ children, style, className, 'aria-labelledby': ariaLabelledby }, ref) => {
    const { user } = useAuth();
    return (
      <div
        ref={ref}
        style={style}
        className={cn('profile-dropdown-content', className)}
        aria-labelledby={ariaLabelledby}
      >
        <div className='profile-dropdown-header d-flex align-items-center gap-2'>
          <ProfileAvatar
            src={user?.profileImage}
            username={user?.username ?? user?.email ?? ''}
            size='sm'
          />
          <span>
            {user?.username ?? user?.email?.split('@')[0] ?? 'Profile'}
          </span>
        </div>
        {children}
      </div>
    );
  }
);

const ProfileDropdown = ({ onLogout }: { onLogout: () => void }) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <>
      <Dropdown className='profile-dropdown'>
        <Dropdown.Toggle
          as={ProfileBtn}
          id='dropdown-custom-components'
        >
          <ProfileAvatar
            src={user?.profileImage}
            username={user?.username ?? user?.email ?? ''}
            size='sm'
          />
        </Dropdown.Toggle>
        <Dropdown.Menu
          as={ProfileBody}
          className='mt-2'
        >
          <div className='profile-dropdown-menu'>
            <Dropdown.Item
              className='profile-dropdown-item'
              onClick={() => navigate('/app/profile')}
            >
              My Profile
            </Dropdown.Item>
            <Dropdown.Item
              className='profile-dropdown-item'
              onClick={() => navigate('/app/settings/general')}
            >
              Settings
            </Dropdown.Item>
            <Dropdown.Item
              className='profile-dropdown-item'
              onClick={onLogout}
            >
              Logout
            </Dropdown.Item>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};
export default ProfileDropdown;
